<template lang="html">
  <b-card>
    <div slot="header">Histórico <b-badge class="badge_blacklist" variant="danger">Blacklist</b-badge></div>
      <div v-for="bl in blacklistData" v-bind:key="bl.id">
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Motivo</label>
          <div class="col-sm-6">
            <div readonly class="form-control-plaintext">CPF {{ bl.cpf }}</div>
          </div>
        </div>
        <div v-if="bl.comment !== null">
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Comentário</label>
            <div class="col-sm-9">
              <div readonly class="form-control-plaintext">{{ bl.comment }}</div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Período</label>
          <div class="col-sm-9">
            <div readonly class="form-control-plaintext">De {{ bl.dateCreated | moment-date }} até {{ bl.blacklistPeriod | moment-date }}</div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Loja</label>
          <div class="col-sm-9">
            <div readonly class="form-control-plaintext">{{ bl.transaction.sellername }}</div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Pedido</label>
          <div class="col-sm-9">
            <div readonly class="form-control-plaintext">{{ bl.transaction.reference }}</div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Transação</label>
          <div class="col-sm-9">
            <div readonly class="form-control-plaintext">{{ bl.transaction.uuid }}</div>
          </div>
        </div>
        <hr />
      </div>
  </b-card>
</template>
<script>
export default {
  props: ['blacklistData']
}
</script>
<style lang="scss">
.badge_blacklist {
  font-size: 112% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/partial/cards/blacklist/BlacklistDetails.vue